<template>
  <div class="row justify-content-center">
    <div :class="isVisible ? 'backdrop' : ''" @click="closePatient"/>
    <div
      :class="!isVisible ? 'd-none' : 'col-md-4'">
      <div class="card card-patient border-0">
        <div
          class="card-body p-0 d-flex flex-column overflow-y-auto"
          :class="{
            'flex-row justify-content-between': !isVisible,
            'flex-column': isVisible
          }">
          <div class="row d-md-none">
            <div class="col d-flex justify-content-center pb-3">
              <div class="tab bg-neutral-300" />
            </div>
          </div>
          <div
            class="patient-list py-md-2 p-0 pb-3"
            :class="{
              'd-md-inline d-none': !isVisible
            }">
            <div
              v-for="datum in data"
              :key="datum"
              @click="setSelectMember(datum)"
              class="patient-item d-flex align-items-center"
            >
              <div class="patient-wrapper d-flex align-items-center justify-content-center bg-info-500 rounded-circle">
                <span class="fw-400 fs-14 lh-18 text-white">
                  {{ getInitialName(datum.anggota_nama) }}
                </span>
              </div>
              <div class="value-wrapper d-flex flex-column">
                <span class="value-wrapper-name fw-700 fs-14 lh-18 color-neutral-900">{{ datum.anggota_nama }}</span>
                <label class="value-wrapper-email fw-400 fs-12 lh-14 color-neutral-600">{{ datum.nama_hubungan }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInitialName } from '@/core/helper'
import { useRouter } from 'vue-router'

export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    const router = useRouter()
    const closePatient = () => {
      if (props.isVisible) {
        router.push({
          query: { showFamilyMember: !props.isVisible }
        })
      }
    }

    const setSelectMember = payload => {
      emit('selectData', payload)
      closePatient()
    }

    return {
      closePatient,
      setSelectMember,
      getInitialName
    }
  }
}
</script>

<style lang="scss" scoped>
.card-patient {
  border-radius: 10px !important;
  box-shadow: 0px 10px 45px rgba(0, 0, 0, 0.05);
  padding-top: 8px;
  z-index: 1000;

  @media (max-width: 767px) {
    position: fixed;
    bottom: 0rem;
    left: 0;
    right: 0;
    transition: all .3s ease-in-out;
    max-height: 80vh;
  }

  @media (min-width: 768px) {
    position: fixed;
    top: 2rem;
    left: 25rem;
    right: 25rem;
    transition: all .3s ease-in-out;
    max-height: 93vh;
  }

  .tab {
    width: 48px;
    height: 4px;
    border-radius: 14px;
  }

  .patient-list {
    padding: 8px 18px 25x;
    border-radius: 20px 20px 0px 0px;

    @media (max-width: 767px) {
      height: 65vh;
      overflow-y: auto;
    }

    .patient-item {
      padding: 12px 18px;
      gap: 8px;
      box-shadow: 0px -1px 0px 0px #F2F2F2CC inset;

      .value-wrapper {
        gap: 4px;
      }

      .btn-wrapper {
        bottom: 0;
      }

      &.active {
        color: white;
        background-color: #8CC63F;
      }
    }

    .patient-wrapper {
      width: 36px;
      height: 36px;
    }
  }
}

.backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10;
}
</style>
